const buildUrl = (view_type, vid, model, id = null, menuId = null) => {
  let _url = `/${view_type}?vid=${vid}&model=${model}`
  if (id) {
    _url += `&id=${id}`
  }
  if (menuId) {
    _url += `&menu=${menuId}`
  }
  return _url
}

export { buildUrl }
